import { useCallback } from 'react';
import { useAppDispatch } from '@shared/hooks/use-app-dispatch.ts';
import { openDialogModal } from '@src/library/redux/modal/index.ts';
import * as st from './styles.module.scss';

type PT = {
  isShouldModalOpen: boolean;
  onModalConfirm: () => void;
  title?: string;
  text?: string;
};

export const useCloseFormDialogModal = () => {
  const dispatch = useAppDispatch();

  const doCloseFormWithDialogModal = useCallback(
    ({ onModalConfirm, isShouldModalOpen, ...props }: PT) =>
      () => {
        isShouldModalOpen
          ? dispatch(
              openDialogModal({
                isButtonsRevert: true,
                buttonClassName: st.buttonn,
                title: 'Закрыть страницу?',
                text: 'Внесенные изменения не сохранятся',
                confirmText: 'Остаться',
                declineText: 'Уйти',
                isNeedClose: true,
                decline: onModalConfirm,
                ...props,
              })
            )
          : onModalConfirm();
      },
    [dispatch]
  );

  return { doCloseFormWithDialogModal };
};
